import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';

import { CrossIcon } from 'assets/icons';
import { usePOST } from 'hooks/useRequest';
import { grey50 } from 'constants/variables';

import SpottedMistakeForm from './spotted_mistake_form';
import SpottedMistakeConfirmation from './spotted_mistake_confirmation';

const SpottedMistake = ({ RECAPTCHA_SITE_KEY, url, useRecaptcha }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [formBody, setFormBody] = useState(false);
  const [formResponseErrors, setFormResponseErrors] = useState(false);

  const closeModal = () => {
    setModalIsOpen(false);
    document.querySelector('.js-spotted-mistake').focus();
  };

  const { data: formSuccess, error: formError } = usePOST(
    formBody ? url : null,
    formBody,
    {
      headers: {
        Accept: 'application/json',
      },
    },
  );

  useEffect(() => {
    // agreed with design to show the message if there is an error from backend
    if (formSuccess) {
      closeModal();
      setShowConfirmationModal(true);
      setFormBody(false);
      setFormResponseErrors(false);
    }
  }, [formSuccess]);

  useEffect(() => {
    if (formError && formError.error) {
      const { data } = formError.error;
      setFormResponseErrors(data);
      setFormBody(false);
    }
  }, [formError]);

  return (
    <>
      <Button
        className="cef-btn cef-btn--grey ff-body fw-600 fs-16 js-spotted-mistake"
        handleClick={() => setModalIsOpen(true)}>
        Spotted a Mistake
      </Button>

      <StyledModal
        className="spotted-mistake__modal"
        isOpen={modalIsOpen}
        closeModal={closeModal}
        config={{ backdropColour: 'rgba(76, 76, 76, 0.9)' }}>
        <CloseIconButton handleClick={closeModal}>
          <CrossIcon fillColor={grey50} width={18} height={18} />
        </CloseIconButton>
        <SpottedMistakeForm
          RECAPTCHA_SITE_KEY={RECAPTCHA_SITE_KEY}
          closeModal={closeModal}
          setFormBody={setFormBody}
          formResponseErrors={formResponseErrors}
          setFormResponseErrors={setFormResponseErrors}
          useRecaptcha={useRecaptcha}
        />
      </StyledModal>

      <StyledModal
        className="spotted-mistake__modal"
        isOpen={showConfirmationModal}
        closeModal={() => {
          setShowConfirmationModal(false);
        }}
        config={{ backdropColour: 'rgba(76, 76, 76, 0.9)' }}>
        <SpottedMistakeConfirmation
          closeModal={() => setShowConfirmationModal(false)}
        />
      </StyledModal>
    </>
  );
};

const StyledModal = styled(Modal)`
  display: none;
  @media screen and (min-width: 768px) {
    display: flex;
  }

  > div {
    width: 75%;
    margin: 0;
    position: relative;

    @media screen and (min-width: 768px) {
      max-width: 650px;
      padding: 4.875rem 5rem;
    }
  }
`;

const CloseIconButton = styled(Button)`
  border: 0;
  background-color: transparent;
  padding: 0;
  width: 44px;
  height: 44px;
  position: absolute;
  top: 22px;
  right: 22px;
`;

export default SpottedMistake;
